<script>

    import ArticleApi from "@shared/_api/article";
    import CustomSelect from "../../../components/ui/CustomSelect";
    import ArticleBase from "../ArticleBase";
    import {mapActions} from "vuex";

    export default {
        name: 'cutomer-category-article-base',
        extends: ArticleBase,
        props: ['article', 'category'],
        components: {
            'custom-select': CustomSelect
        },
        data: function () {
            return {
                articleDetails: null,
                amount: null,
                submitProcessing: false
            }
        },
        methods: {
            ...mapActions('cart', ['addItem', 'fetchCart']),
            wasRecentlyUpdated() {
                let updatedAt = this.article.lastPriceUpdateCustomer || this.article.lastPriceUpdate;
                let referenceDate = new Date();
                referenceDate.setDate(referenceDate.getDate() - 90);

                return updatedAt && new Date(updatedAt) > referenceDate;
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            fetchArticleDetails() {
                if (!this.articleDetails && !this.busy) {
                    this.busy = true;
                    return ArticleApi.customerArticleStubById(this.article.id, this.category.id).then(articleDetails => {
                        this.articleDetails = articleDetails;
                        this.colorSelectCustomerMode = this.variantList.some(variant => variant.articleColor.customerValue);
                        return articleDetails;
                    }).finally(() => {
                        this.busy = false;
                    })
                } else {
                    return Promise.resolve(this.articleDetails);
                }

            },
            selectColor(colorId) {
                this.selectedColor = colorId;
                this.loadVariantPrice();
            },
            selectSize(sizeId) {
                this.selectedSize = sizeId;
                this.loadVariantPrice();
            },
            openContactModal(initialSelection) {
                this.$refs['contact-modal-' + this.article.id].resetData(initialSelection);
                this.$refs['contact-modal-' + this.article.id].show();
            },
            openNegativeStatementInfoModal() {
                this.fetchArticleDetails().then(() => {
                   this.$refs['negative-statement-info-modal-' + this.article.id].resetData();
                   this.$refs['negative-statement-info-modal-' + this.article.id].show();
                    /*if (articleDetails.tarifCode && !(Number(articleDetails.tarifCode.substring(0, 2)) > 49 && Number(articleDetails.tarifCode.substring(0, 2)) < 64)) {
                        this.$refs['negative-statement-info-modal-' + this.article.id].resetData();
                        this.$refs['negative-statement-info-modal-' + this.article.id].show();
                    } else {
                        this.openContactModal();
                    }*/
                });
            },
           openNegativeStatementModal() {
              this.fetchArticleDetails().then(() => {
                 this.$refs['negative-statement-modal-' + this.article.id].resetData();
                 this.$refs['negative-statement-modal-' + this.article.id].show();
                 /*if (articleDetails.tarifCode && !(Number(articleDetails.tarifCode.substring(0, 2)) > 49 && Number(articleDetails.tarifCode.substring(0, 2)) < 64)) {
                     this.$refs['negative-statement-info-modal-' + this.article.id].resetData();
                     this.$refs['negative-statement-info-modal-' + this.article.id].show();
                 } else {
                     this.openContactModal();
                 }*/
              });
           }
        },
        computed: {
            variantImages: function() {
                if(this.articleDetails && this.articleDetails.articleImageList) {
                    return this.articleDetails.articleImageList;
                }
                return [];
            },
            imageList: function () {
                let defaultImageList = this.defaultImages.concat(this.article.cardImg && this.user ? [{media: this.article.cardImg}] : []);

                return defaultImageList.concat(this.variantImages).map((img, index) => {
                    let sizeId = Number(img.sizeId),
                        colorId = Number(img.colorId),
                        size = null,
                        color = null;

                    if (sizeId) {
                        size = this.sizeOptions.find(sizeOption => sizeOption.value == sizeId);
                    }

                    if (colorId) {
                        color = this.colorOptions.find(colorOption => colorOption.value == colorId);
                    }

                    let articleName = this.article.name +  (this.customerArticleNumber ? " - " + this.customerArticleNumber : "");
                    let colorName = color ? " - " + color.diamondValue : "";
                    let customerColorName = color && color.customerValue ? " - " + color.customerValue : "";
                    let sizeName = size ? " - " + size.diamondValue : "";

                    let label =  articleName + colorName + customerColorName + sizeName ;

                    return {label: label, src: this.articleImageResource(img.media, 1000), isDefault: 0, name: img.media};
                });
            },
        }
    }
</script>